import { createContext, useContext } from "react";
import { MotionConfig } from "motion/react";
import { useMotionPreferences } from "../hooks/useMotionPreferences.js";
import { editorialEase } from "./choreography.js";

const MotionModeContext = createContext({
  mode: "static",
  reduced: true,
  coarse: false
});

export function useMotionMode() {
  return useContext(MotionModeContext);
}

export default function MotionDirector({ children }) {
  const preferences = useMotionPreferences();

  return (
    <MotionModeContext.Provider value={preferences}>
      <MotionConfig
        reducedMotion="user"
        transition={{ duration: 0.7, ease: editorialEase }}
      >
        <div className="motion-stage" data-motion-mode={preferences.mode}>
          {children}
        </div>
      </MotionConfig>
    </MotionModeContext.Provider>
  );
}
